{"/":"/fr","/pricing":"/fr/pricing"}